import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  FrameType_BINARY_getInstance322fv5umlaak0 as FrameType_BINARY_getInstance,
  FrameType_TEXT_getInstancegx0aih9zi595 as FrameType_TEXT_getInstance,
  FrameType_CLOSE_getInstance18b0xemwe4t20 as FrameType_CLOSE_getInstance,
  FrameType_PING_getInstance3qbqh4hk4xba as FrameType_PING_getInstance,
  FrameType_PONG_getInstanceql6atakcop4o as FrameType_PONG_getInstance,
} from './FrameType.mjs';
import { NonDisposableHandle_instance3amt6bvd9jgby as NonDisposableHandle_instance } from './FrameCommon.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toByteArray1i3ns5jnoqlv6 as toByteArray,
  writeText19qfzm98fbm4l as writeText,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BinaryClass;
function Binary() {
  if (BinaryClass === VOID) {
    class $ extends Frame() {
      static b5k(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.c5k(fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static d5k(fin, data) {
        return this.b5k(fin, data, false, false, false);
      }
    }
    initMetadataForClass($, 'Binary');
    BinaryClass = $;
  }
  return BinaryClass;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ extends Frame() {
      static l5k(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.c5k(fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static m5k(fin, data) {
        return this.l5k(fin, data, false, false, false);
      }
      static n5k(text) {
        return this.m5k(true, toByteArray(text));
      }
    }
    initMetadataForClass($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var CloseClass;
function Close() {
  if (CloseClass === VOID) {
    class $ extends Frame() {
      static o5k(data) {
        return this.c5k(true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
      static t5g(reason) {
        // Inline function 'io.ktor.utils.io.core.buildPacket' call
        var builder = new (Buffer())();
        builder.x4k(reason.k5f_1);
        writeText(builder, reason.l5f_1);
        return this.p5k(builder);
      }
      static p5k(packet) {
        return this.o5k(readByteArray(packet));
      }
      static q5k() {
        return this.o5k(Companion_getInstance().w5h_1);
      }
    }
    initMetadataForClass($, 'Close', $.q5k);
    CloseClass = $;
  }
  return CloseClass;
}
var PingClass;
function Ping() {
  if (PingClass === VOID) {
    class $ extends Frame() {
      static u5i(data) {
        return this.c5k(true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
    }
    initMetadataForClass($, 'Ping');
    PingClass = $;
  }
  return PingClass;
}
var PongClass;
function Pong() {
  if (PongClass === VOID) {
    class $ extends Frame() {
      static q5h(data, disposableHandle) {
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        return this.c5k(true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
      }
    }
    initMetadataForClass($, 'Pong');
    PongClass = $;
  }
  return PongClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.w5h_1 = new Int8Array(0);
      }
      x5h(fin, frameType, data, rsv1, rsv2, rsv3) {
        var tmp;
        switch (frameType.w1_1) {
          case 1:
            tmp = Binary().b5k(fin, data, rsv1, rsv2, rsv3);
            break;
          case 0:
            tmp = Text().l5k(fin, data, rsv1, rsv2, rsv3);
            break;
          case 2:
            tmp = Close().o5k(data);
            break;
          case 3:
            tmp = Ping().u5i(data);
            break;
          case 4:
            tmp = Pong().q5h(data, NonDisposableHandle_instance);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ {
      static c5k(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
        Companion_getInstance();
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        var $this = createThis(this);
        $this.v5g_1 = fin;
        $this.w5g_1 = frameType;
        $this.x5g_1 = data;
        $this.y5g_1 = disposableHandle;
        $this.z5g_1 = rsv1;
        $this.a5h_1 = rsv2;
        $this.b5h_1 = rsv3;
        return $this;
      }
      toString() {
        return 'Frame ' + this.w5g_1.toString() + ' (fin=' + this.v5g_1 + ', buffer len = ' + this.x5g_1.length + ')';
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance13o6h9kfs12i5,
  Binary as Binary3tlzyfojm51s4,
  Close as Close3tx65evcwi73t,
  Ping as Ping3nta6l7sdq1r9,
  Pong as Pong3m3cas9hmc9ec,
  Text as Text3e6ukp9joohql,
};
//endregion

//# sourceMappingURL=Frame.web.mjs.map
